import React from "react";
import ReactDOM from "react-dom/client";

import { LocaleProvider } from "@app/scripts/react-providers/locales";
import { QuickAdd } from "@app/scripts/react-quick-add/components/QuickAdd";
import { QuickAddPlp } from "@app/scripts/react-quick-add/components/QuickAddPlp";

import type { Product } from "@app/scripts/types";

class QuickAddElem extends HTMLElement {
  static observedAttributes = ["product", "btn-style", "heading", "fg-color", "mode"];

  connectedCallback() {
    const script = this.querySelector("[data-json]");
    const btnStyle = this.getAttribute("btn-style") || "default";
    const fgColor = this.getAttribute("fg-color") || "dark-grey";
    const heading = this.getAttribute("heading") || "Shop the look";
    const mode = this.getAttribute("mode") || "default";

    let product;

    try {
      product = JSON.parse(script?.innerHTML ?? "") as Product;
    } catch (error) {
      console.error(error);
    }

    const mountPoint = this.querySelector(".quick-add-mount") || document.createElement("div");
    mountPoint.classList.add("quick-add-mount");

    this.appendChild(mountPoint);

    const root = ReactDOM.createRoot(mountPoint);
    root.render(
      <LocaleProvider>
        {mode === "plp" ? (
          <QuickAddPlp product={product} className="hide-mobile" />
        ) : (
          <QuickAdd product={product} btnStyle={btnStyle} heading={heading} fgColor={fgColor} />
        )}
      </LocaleProvider>
    );
  }
}

customElements.define("quick-add", QuickAddElem);
